// extracted by mini-css-extract-plugin
module.exports = {"container":"SearchError-module_container_1GRYA","error":"SearchError-module_error_18INi"};